import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGoogleBusinessAccountsQueryVariables = Types.Exact<{
  oauthId: Types.Scalars['UUID']['input'];
}>;


export type GetGoogleBusinessAccountsQuery = { __typename?: 'Query', getGoogleBusinessAccounts: Array<{ __typename?: 'GoogleBusinessAccount', id: string, name: string }> };

export type CreateGoogleBusinessGuestFeedbackIntegrationMutationVariables = Types.Exact<{
  oAuthId: Types.Scalars['UUID']['input'];
  googleBusinessAccountId: Types.Scalars['String']['input'];
  googleBusinessAccountName: Types.Scalars['String']['input'];
}>;


export type CreateGoogleBusinessGuestFeedbackIntegrationMutation = { __typename?: 'Mutation', createGoogleBusinessGuestFeedbackIntegration: { __typename?: 'OrgGuestFeedbackGoogleBusinessMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, orgGuestFeedbackIntegration?: { __typename?: 'OrgGuestFeedbackIntegration', id: string } | null } };


export const GetGoogleBusinessAccountsDocument = gql`
    query GetGoogleBusinessAccounts($oauthId: UUID!) {
  getGoogleBusinessAccounts(oauthId: $oauthId) {
    id
    name
  }
}
    `;

/**
 * __useGetGoogleBusinessAccountsQuery__
 *
 * To run a query within a React component, call `useGetGoogleBusinessAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleBusinessAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleBusinessAccountsQuery({
 *   variables: {
 *      oauthId: // value for 'oauthId'
 *   },
 * });
 */
export function useGetGoogleBusinessAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetGoogleBusinessAccountsQuery, GetGoogleBusinessAccountsQueryVariables> & ({ variables: GetGoogleBusinessAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoogleBusinessAccountsQuery, GetGoogleBusinessAccountsQueryVariables>(GetGoogleBusinessAccountsDocument, options);
      }
export function useGetGoogleBusinessAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoogleBusinessAccountsQuery, GetGoogleBusinessAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoogleBusinessAccountsQuery, GetGoogleBusinessAccountsQueryVariables>(GetGoogleBusinessAccountsDocument, options);
        }
export type GetGoogleBusinessAccountsQueryHookResult = ReturnType<typeof useGetGoogleBusinessAccountsQuery>;
export type GetGoogleBusinessAccountsLazyQueryHookResult = ReturnType<typeof useGetGoogleBusinessAccountsLazyQuery>;
export type GetGoogleBusinessAccountsQueryResult = Apollo.QueryResult<GetGoogleBusinessAccountsQuery, GetGoogleBusinessAccountsQueryVariables>;
export const CreateGoogleBusinessGuestFeedbackIntegrationDocument = gql`
    mutation CreateGoogleBusinessGuestFeedbackIntegration($oAuthId: UUID!, $googleBusinessAccountId: String!, $googleBusinessAccountName: String!) {
  createGoogleBusinessGuestFeedbackIntegration(
    oAuthId: $oAuthId
    googleBusinessAccountId: $googleBusinessAccountId
    googleBusinessAccountName: $googleBusinessAccountName
  ) {
    success
    error {
      message
    }
    orgGuestFeedbackIntegration {
      id
    }
  }
}
    `;
export type CreateGoogleBusinessGuestFeedbackIntegrationMutationFn = Apollo.MutationFunction<CreateGoogleBusinessGuestFeedbackIntegrationMutation, CreateGoogleBusinessGuestFeedbackIntegrationMutationVariables>;

/**
 * __useCreateGoogleBusinessGuestFeedbackIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateGoogleBusinessGuestFeedbackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoogleBusinessGuestFeedbackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoogleBusinessGuestFeedbackIntegrationMutation, { data, loading, error }] = useCreateGoogleBusinessGuestFeedbackIntegrationMutation({
 *   variables: {
 *      oAuthId: // value for 'oAuthId'
 *      googleBusinessAccountId: // value for 'googleBusinessAccountId'
 *      googleBusinessAccountName: // value for 'googleBusinessAccountName'
 *   },
 * });
 */
export function useCreateGoogleBusinessGuestFeedbackIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoogleBusinessGuestFeedbackIntegrationMutation, CreateGoogleBusinessGuestFeedbackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoogleBusinessGuestFeedbackIntegrationMutation, CreateGoogleBusinessGuestFeedbackIntegrationMutationVariables>(CreateGoogleBusinessGuestFeedbackIntegrationDocument, options);
      }
export type CreateGoogleBusinessGuestFeedbackIntegrationMutationHookResult = ReturnType<typeof useCreateGoogleBusinessGuestFeedbackIntegrationMutation>;
export type CreateGoogleBusinessGuestFeedbackIntegrationMutationResult = Apollo.MutationResult<CreateGoogleBusinessGuestFeedbackIntegrationMutation>;
export type CreateGoogleBusinessGuestFeedbackIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateGoogleBusinessGuestFeedbackIntegrationMutation, CreateGoogleBusinessGuestFeedbackIntegrationMutationVariables>;